// 样式相关设置的store
const defaultQuesTipImg = require('@/assets/img/tmp/result.png')

const state = (() => {
  return {
    // 隐藏首页
    isHideHome: false,
    // 结果页提示文字
    resultTipText: undefined,
    // 结果页提示图片
    resultTipImg: '',
    // 结果页完成按钮文字
    finishBtnText: '完成',
    // 结果页证书标题
    certificateTitle: '恭喜您获得一张证书\n请留下您的姓名',
    // 结果页证书按钮
    certificateSubmitBtnText: '领取证书',
    // 结果页证书标题居中设置
    certificateTitleAlign: 'center',
  }
})

const mutations = {
  setIsHideHome(state, payload) {
    state.isHideHome = payload
  },
  setResultTipText(state, payload) {
    state.resultTipText = payload.text
  },
  setResultTipImg(state, payload) {
    state.resultTipImg = payload.img
  },
  setFinishBtnText(state, payload) {
    state.finishBtnText = payload.text
  },
  setCertificateTitle(state, payload) {
    state.certificateTitle = payload.title
  },
  setCertificateSubmitBtnText(state, payload) {
    state.certificateSubmitBtnText = payload.text
  },
  setCertificateTitleAlign(state, payload) {
    state.certificateTitleAlign = payload.data
  }
}

const getters = {
  getIsHideHome(state) {
    return state.isHideHome
  },
  getResultTipText(state, rootState) {
    let text = state.resultTipText

   if (text === undefined) {
      if (rootState.getQuesInfo?.type === 1) {
        text = '填写完成！'
      } else {
        text = '您已完成答题, 感谢参与！'
      }
    }

    return text
  },
  getResultTipImg(state, rootState) {
    // 暂时其实只有问卷有
    if (!state.resultTipImg) {
      if (rootState.getQuesInfo?.type === 1) {
        return defaultQuesTipImg
      }
    }

    return state.resultTipImg
  },
  getFinishBtnText(state, rootState) {
    let text = state.finishBtnText
    if (text === undefined) {
      text = '完成'
    }

    return text
  },
  getCertificateTitle(state) {
    return state.certificateTitle
  },
  getCertificateSubmitBtnText(state) {
    return state.certificateSubmitBtnText
  },
  getCertificateTitleAlign(state) {
    return state.certificateTitleAlign
  }
}

export default {
  state,
  mutations,
  getters
}